const MAX_AUTHORIZATION_ID_LENGTH = 2048;

function consentAuthorizationId(url: string): string | null {
  const value = new URL(url).searchParams.get("authorization_id")?.trim() ?? "";
  return value && value.length <= MAX_AUTHORIZATION_ID_LENGTH ? value : null;
}

/**
 * Return only known local SPA routes. Never redirect to an external origin.
 * Protected deep links (including Voorplanning) must survive the login flow.
 */
export function safeInternalReturnPath(value: string | null): string | null {
  if (!value) return null;
  try {
    const parsed = new URL(value, "https://local.invalid");
    if (parsed.origin !== "https://local.invalid") return null;
    if (parsed.pathname === "/oauth/consent") {
      return consentAuthorizationId(parsed.href) ? parsed.pathname + parsed.search : null;
    }
    if (
      [
        "/",
        "/home/",
        "/reports/",
        "/planning/",
        "/preplanning/",
        "/dwb/",
        "/invite/",
      ].includes(parsed.pathname)
    ) {
      return parsed.pathname + parsed.search;
    }
  } catch {
    return null;
  }
  return null;
}
